import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=10120de8&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.css?vue&type=style&index=0&lang=css&"
import style1 from "./Login.vue?vue&type=style&index=1&id=10120de8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10120de8",
  null
  
)

export default component.exports